
import { useState } from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { OrganizationUsersHeader } from '@/components/admin/organization/OrganizationUsersHeader';
import { OrganizationUsersStats } from '@/components/admin/organization/OrganizationUsersStats';
import { UsersSearch } from '@/components/admin/users/UsersSearch';
import { UsersFilter } from '@/components/admin/users/UsersFilter';
import { UsersContent } from '@/components/admin/users/UsersContent';
import { InviteTeamMemberDialog } from '@/components/admin/organization/InviteTeamMemberDialog';
import { useOrganizationUsers } from '@/hooks/useOrganizationUsers';
import { useUsersFilter } from '@/hooks/useUsersFilter';

export default function OrganizationTeam() {
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);
  
  const {
    users,
    organization,
    loading,
    refreshing,
    handleUserInvited,
    handleUserUpdated,
    handleManualRefresh
  } = useOrganizationUsers();

  const {
    searchQuery,
    setSearchQuery,
    roleFilter,
    setRoleFilter,
    statusFilter,
    setStatusFilter,
    filteredUsers
  } = useUsersFilter(users);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-pulse text-primary">Loading team members...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <OrganizationUsersHeader
        organization={organization}
        onInviteUser={() => setInviteDialogOpen(true)}
        onRefresh={handleManualRefresh}
        refreshing={refreshing}
      />

      <OrganizationUsersStats users={users} organization={organization} />

      <Card>
        <CardHeader>
          <div className="flex flex-col space-y-4">
            <UsersSearch 
              searchQuery={searchQuery}
              onSearchChange={setSearchQuery}
            />
            <UsersFilter 
              roleFilter={roleFilter}
              statusFilter={statusFilter}
              onRoleFilterChange={setRoleFilter}
              onStatusFilterChange={setStatusFilter}
            />
          </div>
        </CardHeader>
        <CardContent>
          <UsersContent 
            users={users}
            filteredUsers={filteredUsers}
            onUserUpdated={handleUserUpdated}
            onManualRefresh={handleManualRefresh}
            refreshing={refreshing}
          />
        </CardContent>
      </Card>

      <InviteTeamMemberDialog
        open={inviteDialogOpen}
        onOpenChange={setInviteDialogOpen}
        onMemberInvited={handleUserInvited}
      />
    </div>
  );
}
